{
  "name": "create-pylon",
  "type": "module",
  "version": "1.1.5-canary-20260508115545.74ba3bff3f7ade973010148205bb756b3e5642cc",
  "description": "CLI for creating a Pylon",
  "scripts": {
    "build": "rimraf ./dist && esbuild ./src/index.ts --bundle --platform=node --target=node18 --format=esm --minify --outdir=./dist --sourcemap=linked --packages=external"
  },
  "bin": "./dist/index.js",
  "files": [
    "dist",
    "templates"
  ],
  "author": "Nico Schett <nico.schett@cronit.io>",
  "license": "Apache-2.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/getcronit/pylon.git",
    "directory": "packages/create-pylon"
  },
  "homepage": "https://pylon.cronit.io",
  "dependencies": {
    "chalk": "^5.3.0",
    "commander": "^12.1.0",
    "conf": "^13.1.0",
    "consola": "^3.2.3",
    "package-manager-detector": "^0.2.9",
    "posthog-node": "^4.10.1",
    "tinyexec": "^0.3.2"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}
